<template>
    <v-container pa-0 ma-0 fluid>
        <h1 class="text-center mb-5">{{$t('general.your_journey')}}</h1>
        <v-row align="center" justify="center">
            <div v-for="(journeyPhase, journeyPhaseIndex) of journeyphases" :key="journeyPhaseIndex"
                 class="mx-5"
            >
                <v-avatar style="background-color: rgba(255, 255, 255, 0.2); transition: all ease-out;"
                          :style="{'transition-duration': ((duration || 0)/6) + 'ms'}"
                          :size="(isStatic && currentPhase.journeyphaseid == journeyPhase.journeyphaseid) || (!isStatic && ((!!previousPhase && previousPhase.journeyphaseid == journeyPhase.journeyphaseid && journeyPhase.journeyphaseid != shrinkingPhaseId) || (currentPhase.journeyphaseid == journeyPhase.journeyphaseid && journeyPhase.journeyphaseid == growingPhaseId))) ? 200 : 100">
                    <transition name="fade">
                        <Animation
                                key="star"
                                :loop-delay="10000"
                                v-if="journeyPhase.phaseorder < currentPhase.phaseorder"
                                style="position: absolute;" url="/animations/star.json">
                        </Animation>
                    </transition>
                    <transition name="fade">
                        <v-img
                                key="profilepic"
                                :src="profilePicUrl"
                                v-if="(isStatic && journeyPhase.phaseorder === currentPhase.phaseorder) || (!isStatic && ((!growingPhaseId && journeyPhase.journeyphaseid == previousPhase.journeyphaseid) || (!!growingPhaseId && journeyPhase.journeyphaseid == growingPhaseId)))"
                                @load="profilePicLoaded = true"
                                style="width: 100%; height: 100%; border: 1px solid white; position: absolute; z-index: 1;"
                        ></v-img>
                    </transition>
                    <transition name="fade">
                        <!--                        v-if=  && currentPhase.journeyphaseid != journeyPhase.journeyphaseid-->
                        <Animation
                                key="lock"
                                v-if="journeyPhase.phaseorder > currentPhase.phaseorder || (!isStatic && currentPhase.journeyphaseid == journeyPhase.journeyphaseid)"
                                style="position: absolute; z-index: 2;"
                                url="/animations/unlock.json"
                                :autoplay="false"
                                :value="growingPhaseId == journeyPhase.journeyphaseid"
                        ></Animation>
                    </transition>
                </v-avatar>
                <p class="mb-0 text-center mt-3">{{$ta(journeyPhase.title_textassetid)}}</p>
            </div>
        </v-row>
    </v-container>
</template>

<script>
    import Animation from "../display/Animation";
    import soundController from "../../lib/soundController";

    export default {
        name: "JourneyPhaseProgress",
        components: {Animation},
        props: {
            mode: {
                type: String,
                default: 'static'
            },
            duration: {
                type: Number,
                default: 4000
            },
            delay: {
                type: Number,
                default: 1000
            }
        },
        data: () => ({
            profilePicLoaded: false,
            smallStyle: {
                width: '130px',
                height: '130px',
            },
            largeStyle: {
                width: '230px',
                height: '230px',
            },
            shrinkingPhaseId: null,
            growingPhaseId: null,
        }),
        computed: {
            isStatic() {
                return this.mode == 'static' || this.isCurrentPhaseFirstInJourney;
            },
            isCurrentPhaseFirstInJourney() {
                return this.$store.getters['assessment/isCurrentPhaseFirstInJourney'];
            },
            currentPhase() {
                return this.$store.state.assessment.journeyplan.journeyphase;
            },
            previousPhase() {
                if (this.currentPhase) {
                    let index = this.journeyphases.findIndex(({journeyphaseid}) => journeyphaseid == this.currentPhase.journeyphaseid);
                    return index > 0 ? this.journeyphases[index - 1] : null;
                } else {
                    return null;
                }
            },
            assessmentjourneyphases() {
                if (!this.$store.state.assessment.assessment.assessmentjourneyphases) return {};
                return this.$store.state.assessment.assessment.assessmentjourneyphases.keyBy('journeyphaseid');
            },
            journeyphases() {
                if (!this.$store.state.journey.journey.journeyphases) return [];
                return this.$store.state.journey.journey.journeyphases;
            },
            profilePicUrl() {
                return this.$store.getters['assessment/assessment'].profilepic.internal_thumbnail_url || this.$store.getters['assessment/assessment'].profilepic.thumbnail_url;
            }
        },
        methods: {
            startAnimation() {
                soundController.achievement();
                let timeoutDuration = ((this.duration || 0) / 6) - 150;
                if (timeoutDuration < 0) {
                    timeoutDuration = 0;
                }
                setTimeout(() => {
                    if (this.previousPhase) {
                        this.shrinkingPhaseId = this.previousPhase.journeyphaseid;
                    }
                    setTimeout(() => {
                        this.growingPhaseId = this.currentPhase.journeyphaseid;
                        setTimeout(() => {
                            this.animationComplete();
                        }, this.duration - (2 * timeoutDuration));
                    }, timeoutDuration);
                }, this.previousPhase ? this.delay : 0);
            },
            animationComplete() {
                this.$emit('complete');
            }
        },
        mounted() {
            this.$store.state.journey.journey.journeyphases.sort((a, b) => a.phaseorder - b.phaseorder);
            if (!this.isStatic && this.duration > 0) {
                this.startAnimation();
            } else if (this.duration > 0) {
                setTimeout(() => {
                    this.animationComplete();
                }, this.duration);
            }
        },
    }
</script>

<style scoped>

</style>